import { DateTime } from 'luxon'

export const toShortDate: any = (isoDate: string) =>
    !!isoDate ? DateTime.fromISO(isoDate).toFormat('dd.MM.yyyy') : null

export const toTime: any = (isoDate: string) => (!!isoDate ? DateTime.fromISO(isoDate).toFormat('HH:mm') : null)
export const toDateTimeFormat: any = (isoDate: string, localizedAt: string) =>
    !!isoDate ? DateTime.fromISO(isoDate).toFormat(`dd.MM.yyyy ${localizedAt ?? ''} HH:mm:ss`) : null
